import { render, staticRenderFns } from "./NewsInfoItem.vue?vue&type=template&id=d4ffbef0&scoped=true&"
import script from "./NewsInfoItem.vue?vue&type=script&lang=js&"
export * from "./NewsInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsInfoItem.vue?vue&type=style&index=0&id=d4ffbef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ffbef0",
  null
  
)

export default component.exports